import { Loader } from "@aws-amplify/ui-react";
import { ExpressCheckoutElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { useCallback, useState } from 'react';
import { styled } from "styled-components";

const StripeWrapper = styled.div`
    width: 100%;
`;

const CheckoutPage = ({
    onSuccess,
    clientSecret,
}) => {
    const stripe = useStripe();
    const elements = useElements();
    const [showSpinner, setShowSpinner] = useState(true);
    const [error, setError] = useState(null);

    const onClick = ({ resolve }) => {
        const options = {
            emailRequired: true
        };
        resolve(options);
    };

    const onReady = ({ availablePaymentMethods }) => {
        console.log("[cardscheckoutpage] onready", { availablePaymentMethods });
        if (availablePaymentMethods) {
            setShowSpinner(false);
        }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onSuccessCards = async () => {
        setShowSpinner(true);
        console.log("Successful payment");
        if (onSuccess) {
            onSuccess();
        }
        setShowSpinner(false);
    };

    const onConfirm = useCallback(async () => {
        const { error } = await stripe.confirmPayment({
            elements,
            clientSecret,
            confirmParams: {
                return_url: 'https://trilo.io',
            },
            redirect: 'if_required',
        });
        if (error && error.message) {
            setError(error.message);
        } else {
            await onSuccessCards();
        }
    }, [clientSecret, elements, onSuccessCards, stripe]);


    if (error !== null) {
        return <div>{error}</div>;
    }

    return (
        <>
            {showSpinner &&
                <Loader size="large" variation="linear" />
            }
            <StripeWrapper style={{ display: showSpinner ? "none" : "inherit" }}>
                <ExpressCheckoutElement
                    onClick={onClick}
                    onConfirm={onConfirm}
                    onReady={onReady}
                />
            </StripeWrapper>
        </>
    );

};

export default CheckoutPage;
